<ng-container *ngIf="!props.isHidden ">
    <div>
        <label *ngIf="props.showLabel" class="form-control-label">{{ props.label }} <span class="text-danger" *ngIf="props.required && props.label">*</span></label>
        <div *ngIf="props.propIsFilter">
            <div *ngFor="let propFields of props.filterOptions" class="mx-2">
                <input class="" type="checkbox" [checked]="propFields.state" [id]="propFields.id"
                    (change)="filterEmitter($event)" />
                <label class="" [for]="propFields.id"> {{ propFields.label }} </label>
            </div>
        </div>
    </div>
    <select class="form-select selection" disableControlName="{{props.readOnly}}"   formControlName="{{ props.field_Name }}"
        [ngClass]="
    formcontrol.value !== '' && formcontrol.value !== null
      ? { blueText: props.isBlueOnChange, reportselect: false, placeholderselect: false }
      : { reportselect: props.isBlueOnChange, blueText: false, placeholderselect: true }" (change)="onMaterialGroupChange($event)">
      <option value="" selected> {{ placeHolder !== null ? placeHolder : props.label ? props.label : props.propcustom ? props.propcustom : 'Select' }}</option>
      <!-- <option value="" selected> {{ 'Select' }}</option> -->
        <!-- {{props.propcustom ? props.propcustom: 'Select'}} -->
        <!-- <option [value]="''"  selected style="display: none;"> Select {{props.label}}</option> -->
        <!-- <option [value]=null  selected style="display: none"> Select {{props.label}}</option> -->
        <option *ngFor="let item of props.options" [ngValue]="item[props.bindValue]">
            {{ item[props.bindLabel] }}
        </option>
    </select>
    
    <div class="error-container">
        <sm-error [control]="formcontrol" [label]="'Field'"></sm-error>

    </div></ng-container>